import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../App';
import { Home } from '../../page';
import ExploreLessonsLoader from '../../components/explore-lessons/ExploreLessonsLoader';

export function Callback() {
  const [loadingDone, setLoadingDone] = useState(false);

  const appContext = useContext(AppContext);

  const {
    headerDetails,
    userName,
    wrapperLevelErrorPage
  } = appContext;

  useEffect(() => {
    console.log('Loading done', headerDetails, userName, wrapperLevelErrorPage);
    if (userName || wrapperLevelErrorPage) {
      setLoadingDone(true);
    } else {
      setLoadingDone(false);
    }
  }, [userName, wrapperLevelErrorPage]);

  if (!loadingDone) {
    return (
      <ExploreLessonsLoader />
    );
  }
  return <Home />;
}